import { Form, Spin } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import seatIcon from '../../../assets/images/booking/seat-timeline.svg';
import iconNew from '../../../assets/images/diagram/ic-new.svg';
import iconPhone from '../../../assets/images/timeline/ic-phone.svg';
import iconPaid from '../../../assets/images/timeline/icon-paid-price.svg';
import iconReserve from '../../../assets/images/timeline/icon-reserve-price.svg';
import '../../../assets/styles/desktop/busBooking.scss';
import { YearFormat } from '../../../config/constant';
import { imageStatusTicket } from '../../../lib/utils';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { getListCustomerBooking, listBookingSelector } from '../../../redux/slice/bookings/listBooking';
import { calculateSegments, groupSegmentsByUnitsWithRowBreak } from '../../../utils/helpers';
import { listColor } from '../../../utils/listColorItem';

function CustomerTimeLine({ listBooking, formSearch, activeKey }: any) {
  const { listCustomerBooking, loadingCustomerBooking: loadingDetail } = useAppSelector(listBookingSelector);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const segments = calculateSegments(listBooking?.schedule?.stops, true, screenWidth);
  const groupedRowsByUnits = groupSegmentsByUnitsWithRowBreak(segments, true);
  const searchDateBooking = dayjs(Form.useWatch('date_booking', formSearch)).format(YearFormat);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (
      listBooking &&
      ((+activeKey === 2 && listBooking?.schedule?.is_diagram) ||
        (+activeKey === 1 && !listBooking?.schedule?.is_diagram))
    ) {
      dispatch(
        getListCustomerBooking({
          schedule_id: listBooking?.schedule?.id,
          depart_date: searchDateBooking,
          type: 'timeline',
        }),
      );
    }
  }, [dispatch, listBooking, activeKey, searchDateBooking]);
  return (
    <Spin spinning={loadingDetail}>
      <div className={`booking-timeline ${listBooking?.schedule?.stops?.length < 5 ? 'min-segment' : ''}`}>
        <div className="w-max mt-3">
          <div className="bottom-title">
            <div className="d-flex w-fit">
              {listBooking?.schedule?.stops?.length
                ? listBooking?.schedule?.stops?.map((item: any, index: number) => (
                    <div
                      key={index}
                      style={{
                        width:
                          listBooking?.schedule?.stops?.length - 1 === index
                            ? 'fit-content'
                            : listBooking?.schedule?.stops?.length === 3
                            ? screenWidth / 3 - 20
                            : listBooking?.schedule?.stops?.length === 4
                            ? screenWidth / 4 - 20
                            : index === listBooking?.schedule?.stops?.length - 1
                            ? 'max-content'
                            : '264px',
                        marginRight: index === listBooking?.schedule?.stops?.length - 2 ? 24 : 4,
                      }}
                      className="d-flex items-center"
                    >
                      <div className="d-flex items-center cursor-pointer w-fit title-segment price">{item?.name}</div>
                    </div>
                  ))
                : ''}
            </div>
          </div>
          <div className="segment-render-block customer">
            <div className="segment-render-content timeline">
              {Object.keys(groupedRowsByUnits)?.map((unit, index: number) => (
                <div key={`unit-${index}`}>
                  {groupedRowsByUnits[unit]?.map((row: any, rowIndex: number) => (
                    <div key={rowIndex} className="segment-render-item block-bg-color-200 timeline">
                      {row.map((segment: any, index: number) => {
                        const infoBookingItem =
                          listCustomerBooking?.length &&
                          listCustomerBooking?.find(
                            (booking: any) =>
                              booking?.segment?.start_location === segment?.from?.name &&
                              booking?.segment?.end_location === segment?.to?.name,
                          );

                        return (
                          <>
                            <div
                              key={index}
                              className={
                                infoBookingItem?.segment?.id
                                  ? `d-flex justify-center block-segment-item segment-render time-line btn-time-line relative  
                                           ${listColor[(segment?.index + 1) % listColor?.length]}`
                                  : ''
                              }
                              style={{
                                minWidth: segment.width + (segment.units - 1) * 8,
                                marginRight: index === listBooking?.schedule?.stops?.length - 2 ? 0 : 8,
                                marginLeft: segment.marginLeft || 0,
                                minHeight: 72,
                              }}
                            >
                              {infoBookingItem?.segment?.id ? (
                                <>
                                  <div
                                    className={`available-block-fixed bg-700
                                           ${listColor[(segment?.index + 1) % listColor?.length]}`}
                                  >
                                    <img src={seatIcon} alt="" />
                                    <p className="fw-700 text-white fs-14">
                                      {infoBookingItem?.total_seat > 0
                                        ? Number(+infoBookingItem?.total_seat - +infoBookingItem?.total_bookings)
                                        : 0}
                                    </p>
                                  </div>
                                  <div
                                    className={`w-100 min-w-240 ${listColor[(segment?.index + 1) % listColor?.length]}`}
                                  >
                                    <div className="w-100 d-flex  justify-between items-start">
                                      <div
                                        className={`${segment?.units > 1 ? 'd-flex gap-x-2' : ''} w-90 ${
                                          listColor[(segment?.index + 1) % listColor?.length]
                                        } color-700 booking-total-timeline`}
                                      >
                                        <div className={`fs-14 d-flex items-center gap-x-4 `}>
                                          <p className="text-blue fw-600">Số lượng khách:</p>
                                          <span
                                            className={`fs-14 fw-600 color-700 ${
                                              listColor[(segment?.index + 1) % listColor?.length]
                                            }`}
                                          >{`${infoBookingItem?.total_bookings ?? ''} / ${
                                            infoBookingItem?.total_seat
                                          }`}</span>
                                        </div>
                                        <div className="fs-14 d-flex items-center gap-x-4">
                                          <p className="text-blue fw-600">Tổng tiền:</p>
                                          <p className={`fs-14 fw-600`}>{infoBookingItem?.total_price ?? 0}</p>
                                          <p className="text-blue fw-600">đ</p>
                                        </div>
                                      </div>
                                    </div>
                                    {infoBookingItem?.bookings?.map((booking: any, index: number) => (
                                      <div className="mt-3" key={index}>
                                        <div className="d-flex space-between">
                                          <div className="d-flex items-center gap-x-4">
                                            <img src={imageStatusTicket(booking)} alt="" width={16} height={16} />
                                            <p className="text-blue fs-14 fw-600">{`${booking?.customer_name} (${booking?.ticket_code})`}</p>
                                          </div>
                                          {segment.units > 1 ? (
                                            <div className="d-flex items-center gap-x-4">
                                              {booking?.status === 'paid' ? <img src={iconPaid} alt="" /> : ''}
                                              {booking?.status === 'reserve' ? <img src={iconReserve} alt="" /> : ''}
                                              <p className="fs-14 fw-600 text-blue">{`${booking?.final_price} VNĐ`}</p>
                                            </div>
                                          ) : (
                                            ''
                                          )}
                                        </div>
                                        <div className="d-flex items-center gap-x-4">
                                          {index === 0 ? <img src={iconNew} alt="" /> : ''}
                                          <img src={iconPhone} alt="" />
                                          <p className="text-blue fw-500 fs-14">{booking?.customer_phone}</p>
                                          <div className="dot-timeline"></div>
                                          <p className="text-blue fw-500 fs-14">Ghế: {booking?.seat_number}</p>
                                        </div>
                                        {segment.units === 1 ? (
                                          <div className="d-flex items-center gap-x-4">
                                            {booking?.status === 'paid' ? <img src={iconPaid} alt="" /> : ''}
                                            {booking?.status === 'reserve' ? <img src={iconReserve} alt="" /> : ''}
                                            <p className="fs-14 fw-600 text-blue">{`${booking?.final_price} VNĐ`}</p>
                                          </div>
                                        ) : (
                                          ''
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </>
                              ) : (
                                ''
                              )}
                            </div>
                          </>
                        );
                      })}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
}
export default CustomerTimeLine;
